export const RANDOM_DISPLAY_NAMES = ["Jules", "Louison", "Adèle"];
